<template>
  <el-table
    v-loading="isLoadingVehicles"
    style="width: 100%"
    :data="vehicles"
    border
    :default-sort="{ prop: 'plate', order: 'ascending' }"
  >
    <el-table-column prop="plate" label="Plate" sortable></el-table-column>
    <el-table-column
      prop="edi_name"
      label="EDI Name"
      sortable
    ></el-table-column>
    <el-table-column prop="make" label="Make"></el-table-column>
    <el-table-column label="Model">
      <template slot-scope="scope">
        {{ scope.row.model + " " + scope.row.sub_model }}
      </template>
    </el-table-column>
    <el-table-column label="Colour">
      <template slot-scope="scope">
        {{ scope.row.basic_colour + " " + scope.row.second_colour }}
      </template>
    </el-table-column>
    <el-table-column prop="power" label="Power"></el-table-column>
    <el-table-column
      prop="tare_weight"
      label="Tare Weight (tonne)"
    ></el-table-column>
    <el-table-column
      prop="gross_vehicle_weight"
      label="GVM (tonne)"
    ></el-table-column>
    <el-table-column prop="type" label="Type"></el-table-column>
    <el-table-column prop="body_style" label="Body Style"></el-table-column>
    <el-table-column
      prop="special_equipments"
      label="Special Equipments"
    ></el-table-column>
    <el-table-column label="Action" align="center">
      <template slot-scope="scope">
        <el-button size="mini" type="text" @click="handleClickEdit(scope.row)"
          >Edit</el-button
        >
        <el-button size="mini" type="text" @click="handleClickQr(scope.row)"
          >QR Code</el-button
        >
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "VehiclesTable",
  components: {},
  data() {
    return {};
  },
  methods: {
    ...mapActions("vehicles", ["openForm"]),
    handleClickEdit(row) {
      console.log(row);
      this.openForm({ vehicle: { ...row } });
      this.$emit('clicked', true)
    },
    handleClickQr(row) {
      window.open(
        "/generate-qr-code/vehicle?truckPlate=" + row.plate,
        "_blank"
      );
    }
  },
  created() {
    this.$store.dispatch("vehicles/loadVehicles");
  },
  computed: {
    ...mapState({
      vehicles: (state) => state.vehicles.vehicles,
      isLoadingVehicles: (state) => state.vehicles.vehiclesLoadStatus === 1,
    }),
  },
};
</script>

<style scoped>
>>> svg {
  vertical-align: unset;
}
</style>